import DOMPurify from "dompurify";
import { useMemo } from "react";

const editorConfig = {
    ALLOWED_TAGS: [
        'p', 'div', 'br', 'hr',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'blockquote', 'pre', 'code',
        'ul', 'ol', 'li',
        'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'del', 'ins',
        'sub', 'sup',
        'a',
        'span',
        'img'
    ],

    ALLOWED_ATTR: [
        'class', 'style', 'id', 'title',
        'href', 'target', 'rel', 'name',
        'data-auto-link', 'src', 'width', 'height', 'alt', 'style'
    ],

    FORBID_ATTR: [
        'onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout',
        'onfocus', 'onblur', 'onkeydown', 'onkeypress', 'onkeyup',
        'onsubmit', 'onchange', 'onselect',
    ],

    ADD_ATTR: ['target', 'rel'],

    ADD_TAGS: [],

    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,

    KEEP_CONTENT: true,

    SAFE_FOR_JQUERY: true,
    SAFE_FOR_TEMPLATES: false,
    WHOLE_DOCUMENT: false,

    RETURN_DOM: false,
    RETURN_DOM_FRAGMENT: false,
    RETURN_DOM_IMPORT: false,
};

export const HTMLPreview = ({ content, className }) => {
    const cleanHtml = useMemo(() => {
        return DOMPurify.sanitize(content, editorConfig);
    }, [content]);

    return <div className={className} dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
}